angular.module('jv.requisition.jobTarget.controller', [])
.controller('ReqsJobTargetCtrl', ['$scope', 'Reqs', '$filter',
function ($scope, Reqs) {

    $scope.post = function () {
        $scope.flags.loading = true;
        Reqs.postToJobTarget($scope.requisitions.jobDetails.EId, $scope.requisitions.selectedlocations,
            function (response) {
                $scope.flags.loading = false;
                $scope.requisitions.jobTargetmodal = false;
                Reqs.jobBoard($scope.params.id, function (requisition) {
                    angular.extend($scope.requisitions, requisition);
                    $scope.requisitions.filteredjobBoards = requisition.jobBoardPost;
                });
                if (response.bean) {
                    var url = response.bean.interactionMetaData;
                    var tab = window.open(url);
                    if (typeof tab === 'undefined') {
                        $scope.showMsg('ENABLE_POPUP', false, 'error');
                    }
                } else {
                    $scope.showMsg('UNABLE_TO_POST_TO_JOBTARGET', false, 'error');
                }
            }
        );
    };
}
]);
